import { useContext } from 'react'
import { AdminModule } from '@golden/gdk-admin'
import { GDKContext } from './GDKProvider'

const useGDK: () => AdminModule = () => useContext(GDKContext)

export default useGDK
